import React from 'react';
import { ProcessForm } from '../production-site-merge-types';

export function StepMainProductionSiteLabel({
  allValues,
}: {
  allValues?: ProcessForm;
}) {
  const productionSite = allValues?.mainProductionSite;

  return (
    <>
      Cílové průmyslové místo: <b>{productionSite?.name}</b>
    </>
  );
}
